import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ReportRecipient } from '@app/interfaces/lm/report-schedules';
import { ProjectStatistics, ProjectStatisticsData } from '@app/interfaces/lm/task';
import { SettingsService } from '@services/sys/settings.service';

@Component({
    selector: 'app-project-progress',
    templateUrl: './project-progress.component.html',
    styleUrls: ['./project-progress.component.less'],
})
export class ProjectProgressComponent implements OnInit{
    @Input() showTitle = true;
    @Input() statisticsType = '';
    @Input('info') set set_info(value: ProjectStatistics) {
        if (value && JSON.stringify(value) !== '{}') {
            this.info = value;
            this.calcProgress();
        }
    }
    @Input() currentUser!: ReportRecipient;
    info: ProjectStatistics = {} as ProjectStatistics;
    totalCount = 0;
    testCaseCount = 0;
    testCaseProgress = 0;
    documentReviewedCount = 0;
    otherTaskCount = 0;
    averageTaskProgress = 0;
    averageOtherTaskProgress = 0;
    averageDocumentReviewTaskProgress = 0;

    constructor(private settingService: SettingsService) {
    }

    ngOnInit(): void {
    }

    calcProgress(): void {
        const { totalTask, totalTestCase, completedTestCase, averageTaskProgress, totalDocumentReviewTask, totalOtherTask,
            averageOtherTaskProgress, averageDocumentReviewTaskProgress } = this.info;
        this.totalCount = totalTask;
        this.averageTaskProgress = averageTaskProgress;
        this.averageOtherTaskProgress = averageOtherTaskProgress;
        this.averageDocumentReviewTaskProgress = averageDocumentReviewTaskProgress;
        this.testCaseCount = totalTestCase;
        this.testCaseProgress = this.settingService.getPercent(completedTestCase, this.testCaseCount);
        this.documentReviewedCount = totalDocumentReviewTask;
        this.otherTaskCount = totalOtherTask;
    }
}
